import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

/**
 * Wraps routes to handle post-login redirect and MSAL loading state.
 * Redirects authenticated users from the landing page to /chat.
 */
export const AuthLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    const userClickedExplore = sessionStorage.getItem('userClickedExplore') === 'true';

    if (isAuthenticated && window.location.pathname === '/' && userClickedExplore) {
      sessionStorage.removeItem('userClickedExplore');
      navigate('/chat', { replace: true });
    }
  }, [inProgress, isAuthenticated, navigate]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#42B0D5] mx-auto mb-4"></div>
          <p className="text-white text-lg">Authenticating...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthLoader;
